export default function assetTypesReducer(state = [], { type, id, payload }) {
  let newState = ''
  switch (type) {
    case 'assetTypesInitialStore':
      if (payload === null) {
        console.error('Error in assetsType initial store')
        return []
      }
      if (!payload[0]) {
        console.warn('No assetsType in store!')
        return []
      }
      if (!payload[0].assettypes) {
        console.warn("AssetsType's store empty!")
        return []
      }
      return payload[0].assettypes

    case 'assetTypeNew':
      newState = Object.values(state)
      newState.unshift(payload)
      return { ...newState }

    case 'atualizaTipoAtivo':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (id === data[1].id) {
          //console.log('Paypay', payload);
          switch (payload.campo) {
            case 'Velmax':
              newState[data[0]].info.velmax = payload.valor
              break
            default:
              console.error('Erro no assets reducer, atualiza Ativo sem campo preparado para atualizar')
          }
        }
      })
      return Object.assign({}, state, newState)

    case 'updateassetTypeNew':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (payload.id === data[1].id) {
          newState[data[0]].info.velmax = payload.valor
          return newState
        }
      })
      return Object.assign({}, state, newState)

    case 'deletaTipoAtivos':
      newState = state
      Object.entries(newState).forEach((data) => {
        if (payload.indexOf(data[1].id) !== -1) delete newState[data[0]]
      })
      return { ...newState }

    case 'updatedeleteassetTypeNew':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (payload.id === data[1].id) delete newState[data[0]]
      })
      return Object.assign({}, newState)
    default:
      return state
  }
}
